import { render, staticRenderFns } from "./EditAmount.vue?vue&type=template&id=5f64548d&scoped=true&"
import script from "./EditAmount.vue?vue&type=script&lang=js&"
export * from "./EditAmount.vue?vue&type=script&lang=js&"
import style0 from "./EditAmount.vue?vue&type=style&index=0&id=5f64548d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64548d",
  null
  
)

export default component.exports